module.exports = __webpack_public_path__ + "static/media/oauth-google.dadc9df7.svg";